/* jshint esversion: 6 */
import store from '@/store'

// 从来访二级域名解析出子系统
export function getSubSys() {
  return document.domain.substr(0, document.domain.indexOf('.')).toUpperCase()
}

export function hasPerm(perm) {
  return store.getters.roles.indexOf(perm) > -1
}

export function clone(obj) {
  return clone2(obj, [])
}

export function clone2(obj, historyArr) {
  const idx = historyArr.indexOf(obj)
  if (idx >= 0) {
    return historyArr[idx]
  }
  historyArr.push(obj)

  if (obj === null || typeof (obj) !== 'object') {
    return obj
  }
  // Handle Date
  if (obj instanceof Date) {
    var copy = new Date()
    copy.setTime(obj.getTime())
    return copy
  }

  // Handle Array
  if (obj instanceof Array) {
    const copy = []
    const len = obj.length
    for (let i = 0; i < len; ++i) {
      copy[i] = clone2(obj[i], historyArr)
    }
    return copy
  }

  // Handle Object
  if (obj instanceof Object) {
    const copy = {}
    for (const attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = clone2(obj[attr], historyArr)
      }
    }
    return copy
  }

  throw new Error("Unable to copy obj! Its type isn't supported.")
}

export function cloneObj(source, target) {
  let src = clone(source)
  for (let i in target) {
    target[i] = src[i]
  }
  Object.assign(target, src)
}

export function stringify(obj, blankArray) {
  return JSON.stringify(obj, function (key, val) {
    if (val != null && typeof (val) === 'object') {
      if (blankArray.indexOf(val) >= 0) {
        return
      }
      blankArray.push(val)
    }
    return val
  })
}

/* source被编辑为target,找到他们变化的内容，并保留id */
export function findChange(sourceRef, editTarget, idName) {
  const result = {}
  let count = 0
  for (const f in editTarget) {
    if (sourceRef[f] === null || sourceRef[f] === undefined) {
      if (editTarget[f] !== null && editTarget[f] !== undefined) {
        result[f] = editTarget[f] // 源中没有的字段视为新增数据
        count++
      }
      continue
    }
    if (typeof (editTarget[f]) === 'object' && !(editTarget[f] instanceof Date)) {
      if (stringify(editTarget[f], []) !== stringify(sourceRef[f], [])) {
        if (editTarget[f] !== null && editTarget[f] !== undefined) {
          const obj = findChange(sourceRef[f], editTarget[f])
          if (obj) {
            result[f] = obj
            count++
          }
        }
      }
    } else {
      if (editTarget[f] !== sourceRef[f]) {
        if (editTarget[f] !== null && editTarget[f] !== undefined) {
          result[f] = editTarget[f]
          count++
        }
      }
    }
  }
  if (count === 0) {
    return false
  }
  if (idName) {
    result[idName] = editTarget[idName]
  }
  return result
}

export function clearObj(source, history = []) {
  for (const f in source) {
    if (source[f]) {
      if (typeof (source[f]) === 'string') {
        source[f] = ''
      } else if (source[f].constructor === Date) {
        source[f] = new Date()
      } else if (typeof (source[f]) === 'number') {
        source[f] = 0
      } else if (source[f].constructor === Array) {
        source[f] = []
      } else {
        if (history.indexOf(source[f]) >= 0) {
          source[f] = null
        } else {
          history.push(source[f])
          clearObj(source[f], history)
        }
      }
    }
  }
}

export function changeRef2Obj(targetObject, jsonObject) {
  if (targetObject instanceof Array) {
    changeRefArray(targetObject, jsonObject)
    return
  }
  for (const f in targetObject) {
    if (f === '$ref') {
      // if (targetObject['$ref'] === '..' || targetObject['$ref'] === '@') {
      if (!targetObject['$ref'].startsWith('$.')) {
        delete targetObject['$ref']
        continue
      }
      Object.assign(targetObject, eval('jsonObject' + targetObject['$ref'].substring(1)))
      delete targetObject['$ref']
    } else if (targetObject[f] instanceof Array) {
      changeRefArray(targetObject[f], jsonObject)
    } else if (typeof (targetObject[f]) === 'object') {
      changeRef2Obj(targetObject[f], jsonObject)
    }
  }
}

export function changeRefArray(jsonArray, jsonObject) {
  jsonArray.forEach(e => {
    changeRef2Obj(e, jsonObject)
  })
}

export function changeRef(jsonObject) {
  if (jsonObject instanceof Array) {
    changeRefArray(jsonObject, jsonObject)
    return jsonObject
  }
  for (const f in jsonObject) {
    if (typeof (jsonObject[f]) === 'object') {
      changeRef2Obj(jsonObject[f], jsonObject)
    }
  }
  return jsonObject
}

export function findConstList(className, enumName) {
  return store.getters.serverconst[className][enumName]
}

export function findConstName(className, enumName, idx) {
  let arr = findConstList(className, enumName)
  if (!isEmpty(arr)) {
    return arr[idx]
  }
  return ''
}

export function isEmpty(str) {
  if (str == null || str === undefined || str === '') {
    return true
  }
  if (str instanceof String) {
    return str.replace(/(^s*)|(s*$)/g, '').length === 0
  }
  if (str instanceof Array) {
    return str.length === 0
  }
  if (str instanceof Object) {
    let count = 0
    for (let key in str) {
      count++
    }
    return count === 0
  }


  return false
}

export function getAliyunOssURI() {
  return 'https://oss.eanfang.net/'
}

export function getAliyunPath(file) {
  return getAliyunOssURI() + file
}

export function getBuildInAvatarSrc(id) {
  return '/static/avatars/avatar' + id + '.png'
}

export function getBaseData() {
  return store.getters.basedata
}

export function getBaseDataByType(typeID) {
  return getBaseData().filter(e => {
    return e.dataType === typeID
  })
}

export function getBaseDataArea() {
  return getBaseDataByType(3)
}

export function getBaseDataIndustry() {
  return getBaseDataByType(4)
}

export function getBaseDataBizType() {
  return getBaseDataByType(2)
}

export function getBaseDataSysType() {
  return getBaseDataByType(1)
}

export function getBizTypeById(id) {
  const list = getBaseDataBizType()[0].children
  for (const i in list) {
    if (list[i].dataId === id) {
      return list[i]
    }
  }
  return {}
}

export function getSysTypeById(id) {
  const list = getBaseDataSysType()[0].children
  for (const i in list) {
    if (list[i].dataId === id) {
      return list[i]
    }
  }
  return {}
}

export function getBaseDataIndustryForSelect() {
  // return getBaseDataForSelect(4, 2, 3)
  return getBaseDataByType(4)[0].children
}

export function getBaseDataAreaForSelect() {
  // return getBaseDataForSelect(3, 2, 4)
  return getBaseDataByType(3)[0].children
}

export function getBaseDataBusinessForSelect() {
  // return getBaseDataForSelect(3, 2, 4)
  return getBaseDataByType(1)[0].children
}

export function getCitys() {
  const result = []
  getBaseDataAreaForSelect().forEach((e) => {
    const item = clone(e)
    if (item.children) {
      item.children.forEach((elem) => {
        elem.children = null
      })
    }
    result.push(item)
  })
  return result
}

export function findByName(list, name) {
  let result = null
  list.forEach(e => {
    if (name.indexOf(e.dataName) > -1) {
      result = e
      return
    }
  })
  return result
}

export function getAreaCode(province, city, county) {
  const provinceNode = findByName(getBaseDataByType(3)[0].children, province)
  if (provinceNode == null) {
    return {}
  }

  const cityNode = findByName(provinceNode.children, city)
  if (cityNode == null) {
    return {}
  }

  const countyNode = findByName(cityNode.children, county)
  if (countyNode == null) {
    return {}
  }
  return countyNode
}

export function findBaseDataFromNodeList(nodeList, code) {
  let result = {}
  nodeList.forEach(e => {
    if (e.dataCode === code) {
      result = e
      return
    }
  })
  return result
}

// 根据code 获取 name 列表
export function findBaseDataByCode(code) {
  if (!code || code === '') {
    return []
  }
  const codeArr = code.split('.')
  const result = []
  let nodeScope = getBaseData() // 初始为树的顶级列表

  let subCode = ''
  for (let i = 0; i < codeArr.length; i++) {
    if (i === 0) {
      subCode = codeArr[0]
    } else {
      subCode += '.' + codeArr[i]
    }
    const subNode = findBaseDataFromNodeList(nodeScope, subCode)
    nodeScope = subNode.children
    result.push(subNode)
  }

  return result
}

/**
 * 根据id 获取到省份信息
 * @param id
 * @returns {{}}
 */
export function findProvinceById(id) {
  if (!id || id === '') {
    return {};
  }
  return getBaseDataArea.filter((e) => e.dataId == id);

}

/**
 * 根据id 获取 基础数据的第一级（电视监控、维修）
 * @param id
 * @returns {*}
 */
export function findBaseDataOneById(id) {
  //循环基础数据
  let basedata
  getBaseData().forEach((e) => {
    let result1 = e.children.filter((data) => data.dataId == id);
    if(result1.length>0){
      basedata = result1[0];
    }
  });
  return basedata
}


// /**
//  * 根据code 获取 拼接后的地址信息
//  * @param code
//  * @returns {string}
//  */
// export function getAreaInfoByCode(code) {
//   const arrInfo = findBaseDataByCode(code)
//   return arrInfo[0] + ' - ' + arrInfo[1] + ' - ' + arrInfo[2]
// }

export function getCodeByArray(nodeArray) {
  if (nodeArray.length > 0) {
    return nodeArray[nodeArray.length - 1]
  }
  return ''
}

export function getBaseDataNameByCode(code) {
  let result = ''
  let i = 0
  findBaseDataByCode(code).forEach(e => {
    if (i++ > 0) {
      if (result !== '') {
        result += '/'
      }
      result += e.dataName
    }
  })
  return result
}

export function getBaseDataLastNameByCode(code) {
  if (code) {
    const arr = findBaseDataByCode(code)
    return arr[arr.length - 1].dataName
  }
  return "";
}

export function findCascaderNode(cascader, value, cascaderProps) {
  let valueProp = 'value'
  let childrenProp = 'children'
  if (cascaderProps.value) {
    valueProp = cascaderProps.value
  }
  if (cascaderProps.children) {
    childrenProp = cascaderProps.children
  }

  for (let i = 0; i < cascader.options.length; i++) {
    const result = findCascaderNodeByParent(cascader.options[i], value, valueProp, childrenProp)
    if (result !== undefined) {
      return result
    }
  }
}

export function findCascaderNodeByParent(parent, value, valueProp, childrenProp) {
  if (parent[valueProp] === value) {
    return parent
  }
  if (!parent.children) {
    return undefined
  }
  for (let i = 0; i < parent.children.length; i++) {
    const result = findCascaderNodeByParent(parent[childrenProp][i], value, valueProp, childrenProp)
    if (result !== undefined) {
      return result
    }
  }
}

// 城市配置获取id
export function getCityID(pid, id, value) {
  const arr = []
  const city = getBaseDataArea()
  // 省
  if (pid == '') {
    getBaseDataArea().forEach(e => {
      e.children.filter(e => {
        if (e.dataName.indexOf(value) > -1) {
          arr.push(e.dataId)
        }
      })
    })
  } else {
    let arrcity = []
    getBaseDataArea().forEach(e => {
      e.children.forEach(e => {
        if (e.dataCode == pid) {
          arrcity = e.children
        }
      })
    })
    // 市
    if (id == '') {
      arrcity.filter(e => {
        if (e.dataName.indexOf(value) > -1) {
          arr.push(e.dataId)
        }
      })
    }
    // 县
    else {
      arrcity.forEach(e => {
        e.children.filter(e => {
          if (e.dataName.indexOf(value) > -1) {
            arr.push(e.dataId)
          }
        })
      })
    }
  }
  return arr
}

// 根据省市县获取id
export function getCityNameId(city, pname, aname) {
  const citys = city.substring(0, city.length - 1)
  // const pnames = pname.substring(0, pname.length - 1)
  // const anames = aname.substring(0, aname.length - 1)
  const data = {
    id: '',
    code: ''
  }
  const arr1 = []
  const arr2 = []
  getBaseDataArea().forEach(e => {
    e.children.filter(e => {
      if (e.dataName.indexOf(citys) > -1) {
        arr1.push(e.children)
      }
    })
  })
  arr1.forEach(e => {
    e.filter(e => {
      if (e.dataName.indexOf(pname) > -1) {
        arr2.push(e.children)
      }
    })
  })
  arr2.forEach(e => {
    e.filter(e => {
      if (e.dataName.indexOf(aname) > -1) {
        data.id = e.dataId
        data.code = e.dataCode
      }
    })
  })
  return data
}

// 三级分类
export function getBaseDataTypeForSelect() {
  // return getBaseDataForSelect(3, 2, 4)
  return getBaseDataByType(1)[0].children
}

// 根据三级code获取1，2，3级名字
export function getBaseDataTotalName(code) {
  let name = "";
  if (code){
    const len2 = code.indexOf('.', code.indexOf('.') + 1)// 第二个小数点
    const data2 = code.substring(len2 + 1, code.length)
    const len3 = data2.indexOf('.') + 1 + len2 // 第三个小数点

    const name1 = getBaseDataLastNameByCode(code.substring(0, len2).toString())
    const name2 = getBaseDataLastNameByCode(code.substring(0, len3).toString())
    const name3 = getBaseDataLastNameByCode(code.toString())
    name = name1 + '-' + name2 + '-' + name3
  }
  return name
}

// 根据三级code获取2级名字
export function getBaseDataTwoName(code) {
  const len2 = code.indexOf('.', code.indexOf('.') + 1)// 第二个小数点
  const data2 = code.substring(len2 + 1, code.length)
  const len3 = data2.indexOf('.') + 1 + len2 // 第三个小数点

  const name2 = getBaseDataLastNameByCode(code.substring(0, len3).toString())
  return name2
}

// 根据三级code获取1级名字
export function getBaseDataOneName(code) {
  const len2 = code.indexOf('.', code.indexOf('.') + 1)// 第二个小数点
  const data2 = code.substring(len2 + 1, code.length)
  // const len3 = data2.indexOf('.') + 1 + len2 // 第三个小数点
  const name1 = getBaseDataLastNameByCode(code.substring(0, len2).toString())
  return name1
}



// WEBPACK FOOTER //
// ./src/common/common.js